import type { CarnivalAction, CarnivalGameState } from "../types";
import { applyRevealSin } from "./reveal-sin";
import { applySelectSin } from "./select-sin";

export function applyAction(
  state: CarnivalGameState,
  action: CarnivalAction,
): CarnivalGameState {
  switch (action.type) {
    case "SelectSin":
      return applySelectSin(state, action);
    case "RevealSin":
      return applyRevealSin(state, action);
  }
}

export * from "./resolve-sin";
export * from "./reveal-sin";
export * from "./round-cascade";
export * from "./select-sin";
